const getters = {};

export default getters;
export type EventHeartbeatGetters = typeof getters;
